// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.facebook-link {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  color: inherit;
  transition: transform var(--transition), opacity var(--transition);
}

.facebook-link__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #1877f2;
}

.facebook-link__icon svg {
  width: 100%;
  height: 100%;
}

.facebook-link--icon .facebook-link__icon {
  width: 2.25rem;
  height: 2.25rem;
}

.facebook-link--icon:hover,
.facebook-link--icon:focus-visible {
  transform: translateY(-2px);
  opacity: 0.85;
}

.facebook-link--labeled {
  padding: 0.6rem 1.1rem;
  border-radius: var(--radius-pill);
  border: 1px solid var(--border-subtle);
  background: var(--bg-surface);
  font-weight: 600;
  font-size: 0.9rem;
  color: var(--text-primary);
  box-shadow: var(--shadow-sm);
}

.facebook-link--labeled .facebook-link__icon {
  width: 1.4rem;
  height: 1.4rem;
}

.facebook-link--labeled:hover,
.facebook-link--labeled:focus-visible {
  border-color: #1877f2;
  color: #1877f2;
  transform: translateY(-2px);
  box-shadow: var(--shadow);
}

.facebook-link:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: 3px;
  border-radius: var(--radius-sm);
}
`, "",{"version":3,"sources":["webpack://./src/shared/components/FacebookLink/FacebookLink.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,kEAAkE;AACpE;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,iCAAiC;EACjC,sCAAsC;EACtC,6BAA6B;EAC7B,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;EACrB,cAAc;EACd,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,+BAA+B;AACjC","sourcesContent":[".facebook-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  color: inherit;\n  transition: transform var(--transition), opacity var(--transition);\n}\n\n.facebook-link__icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: #1877f2;\n}\n\n.facebook-link__icon svg {\n  width: 100%;\n  height: 100%;\n}\n\n.facebook-link--icon .facebook-link__icon {\n  width: 2.25rem;\n  height: 2.25rem;\n}\n\n.facebook-link--icon:hover,\n.facebook-link--icon:focus-visible {\n  transform: translateY(-2px);\n  opacity: 0.85;\n}\n\n.facebook-link--labeled {\n  padding: 0.6rem 1.1rem;\n  border-radius: var(--radius-pill);\n  border: 1px solid var(--border-subtle);\n  background: var(--bg-surface);\n  font-weight: 600;\n  font-size: 0.9rem;\n  color: var(--text-primary);\n  box-shadow: var(--shadow-sm);\n}\n\n.facebook-link--labeled .facebook-link__icon {\n  width: 1.4rem;\n  height: 1.4rem;\n}\n\n.facebook-link--labeled:hover,\n.facebook-link--labeled:focus-visible {\n  border-color: #1877f2;\n  color: #1877f2;\n  transform: translateY(-2px);\n  box-shadow: var(--shadow);\n}\n\n.facebook-link:focus-visible {\n  outline: 2px solid var(--focus-ring);\n  outline-offset: 3px;\n  border-radius: var(--radius-sm);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
